var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CycleClientRendering',[_c('IframeClean',{attrs:{"href":_vm.link.href,"form-method":_vm.formMethod,"form-path":_vm.formPath,"form-parameters":_vm.formParameters}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }